module.exports = __webpack_public_path__ + "img/veloshop.ca_technicien1__1551460933_76.67.188.141.8af65752.jpg";